import * as angular from "angular";
import { FieldDataProvider } from "../../data-provider/field.dp";
import { DataRecord } from "../../models/data-record.model";
import { ActivityDataProvider } from "../../data-provider/activity.dp";
import { UserDataProvider } from "../../data-provider/user.dp";
import { DialogUtils } from "../../helper/dialog.helper";
import { ToastUtils } from "../../helper/toast.helper";
import { DataRecordDataProvider } from "../../data-provider/data-record.dp";

let DataRecordDialogComponent = {
    selector: "vcDataRecordDialog",
    templateUrl:
        "/angular/components/data-record/data-record-dialog.component.html",
    bindings: {
        disableSave: "=?",
        hideCancel: "=?",
    },
    controller: class DataRecordDialogController {
        // * bindings for typescript compiler *
        public disableSave?: any;
        public hideCancel?: any;
        // ************************************

        private __env: any;
        private dialog: DialogUtils;
        private toast: ToastUtils;

        private userDataProvider: UserDataProvider;
        private activityDataProvider: ActivityDataProvider;
        private dataProvider: DataRecordDataProvider;
        private fieldDataProvider: FieldDataProvider;

        public datarecord: DataRecord;
        public user;
        public subprocessors;
        public options;
        public dynamicFields = [];
        public dynamicFieldNames: any[];

        constructor(
            __env: any,
            DialogUtils: DialogUtils,
            ToastUtils: ToastUtils,
            UserDataProvider: UserDataProvider,
            ActivityDataProvider: ActivityDataProvider,
            FieldDataProvider: FieldDataProvider,
            DataRecordDataProvider: DataRecordDataProvider
        ) {
            this.__env = __env;
            this.toast = ToastUtils;
            this.dialog = DialogUtils;

            this.userDataProvider = UserDataProvider;
            this.activityDataProvider = ActivityDataProvider;
            this.fieldDataProvider = FieldDataProvider;
            this.dataProvider = DataRecordDataProvider;

            this.user = this.userDataProvider.getActiveUser();
            this.subprocessors = [
                {
                    name: "Amazon Web Services, Inc",
                    description: "Cloud-hosted computing platform",
                    link: "https://aws.amazon.com/",
                },
                {
                    name: "Auth0",
                    description:
                        "Identification and Authentication, User Management",
                    link: "https://auth0.com/",
                },
                {
                    name: "Authy",
                    description: "Two Factor Authenication for User Management",
                    link: "https://authy.com/",
                },
                {
                    name: "Baremetrics",
                    description: "Track status and payment status of customers",
                    link: "https://baremetrics.com/",
                },
                {
                    name: "CallHub",
                    description:
                        "Voice & SMS intergration. Syncs contacts and interactions between Ecanvasser and CallHub (customer determined integration)",
                    link: "https://callhub.io/",
                },
                {
                    name: "Facebook",
                    description: "Social Media Integration",
                    link: "https://www.facebook.com/",
                },
                {
                    name: "Google Analytics",
                    description: "Web Analytics",
                    link: "https://analytics.google.com/",
                },
                {
                    name: "Google API",
                    description:
                        "Contact addresses are geocoded using google API and plotted on a map in the product.\nWe send a request for geo data when required by customer.",
                    link: "https://cloud.google.com/terms/data-processing-terms",
                },
                {
                    name: "Google Firebase",
                    description: "Track customer software crashes in product",
                    link: "https://firebase.google.com/",
                },
                {
                    name: "Google Tag Manager",
                    description: "Conversion tracking",
                    link: "https://tagmanager.google.com",
                },
                {
                    name: "Hotjar",
                    description: "Web Analytics",
                    link: "https://www.hotjar.com/",
                },
                {
                    name: "Hubspot",
                    description:
                        "CRM platform - Manage and contact leads and customers",
                    link: "https://www.hubspot.com/",
                },
                {
                    name: "Intercom",
                    description:
                        "Manage and contact customers, provide support",
                    link: "https://www.intercom.com/legal/privacy",
                },
                {
                    name: "Mailchimp",
                    description:
                        "Email Marketing integration. Syncs contacts between Ecanvasser and Mailchimp (customer determined)",
                    link: "https://mailchimp.com/",
                },
                {
                    name: "NationBuilder",
                    description:
                        "Customer Relationship Management Integration. Syncs Contacts and Interactions between Ecanvasser and NationBuilder(customer determined)",
                    link: "https://nationbuilder.com/",
                },
                {
                    name: "PandaDoc",
                    description: "Sales Contract Management",
                    link: "https://www.pandadoc.com/",
                },
                {
                    name: "Salesforce",
                    description:
                        "Customer Relationship Management Integration. Syncs Contacts and Interactions between Ecanvasser and Salesforce (customer determined)",
                    link: "https://www.salesforce.com/",
                },
                {
                    name: "Stripe",
                    description:
                        "Issues Invoices and Receive payments from customers",
                    link: "https://stripe.com/",
                },
                {
                    name: "Vonage (aka Nexmo)",
                    description: "VOIP and Telecom",
                    link: "https://www.vonage.com/",
                },
                {
                    name: "Inmoment (aka Wootric)",
                    description: "Net Promotor Score platform",
                    link: "https://inmoment.com/wootric/",
                },
                {
                    name: "Xero",
                    description:
                        "Accounting software - Issue and track invoices to leads and customers",
                    link: "https://www.xero.com/",
                },
            ];
            this.options = {
                ethnicity: "Information on racial and ethnic origin",
                religion: "Information on political opinions",
                politicalopinion:
                    "Information on religious or philosophical beliefs",
                tradeunionmembership: "Information on trade union membership",
                geneticdata: "Genetic data",
                biometricdata: "Biometric data",
                healthinformation: "Information on health",
                gender: "Information on sex life/sexual orientation data",
            };

            this.fieldDataProvider.getAllFields().then((fields) => {
                this.dynamicFieldNames = [
                    ...fields.priority,
                    ...fields.nonpriority,
                    fields.priorityDisabled,
                ].filter((field) => field.hokey != "yob" && !field.cfid);

                angular.forEach(this.dynamicFieldNames, (field) => {
                    this.dynamicFields[`${field.hokey}`] = field.name;
                });
            });
        }

        $onInit() {
            this.dataProvider.getDataRecord().then((dataRecord) => {
                if (dataRecord) {
                    this.datarecord = dataRecord;
                } else {
                    this.datarecord = new DataRecord();
                }
                this.datarecord.version = this.__env.datarecordversion;
            });
        }

        cancel() {
            this.dialog.cancel();
        }

        confirm() {
            let htmlCreated = this.makeHTML();
            this.disableSave = true;
            if (!this.datarecord.id) {
                this.dataProvider
                    .createDataRecord(this.datarecord, htmlCreated)
                    .then((dataRecord) => {
                        this.activityDataProvider.clearAll();
                        this.toast.success(
                            "Record of Data Processing Activities created"
                        );
                        this.dialog.hide(dataRecord);
                    });
            } else {
                this.dataProvider
                    .updateDataRecord(this.datarecord, htmlCreated)
                    .then((dataRecord) => {
                        this.toast.success(
                            "Record of Data Processing Activities updated"
                        );
                        window.open(dataRecord.datarecordlink);
                        this.dialog.hide(dataRecord);
                    });
            }
        }

        makeHTML() {
            let date = new Date();
            let str = date.toString();
            let dtr_title = document.getElementById("dtr-title").innerHTML;
            let section_01 = document.getElementById("section-01");
            let section_02 = document.getElementById("section-02").innerHTML;
            let section_03 = document.getElementById("section-03").innerHTML;
            let section_04 = document.getElementById("section-04").innerHTML;
            let section_05 = document.getElementById("section-05").innerHTML;
            let section_06 = document.getElementById("section-06");
            let section_07 = document.getElementById("section-07");
            let section_08 = document.getElementById("section-08").innerHTML;
            let section_09 = document.getElementById("section-09").innerHTML;
            let section_10 = document.getElementById("section-10").innerHTML;

            let html =
                "<!DOCTYPE html>" +
                "<html lang='en'>" +
                "<head>" +
                "<style>" +
                "table {border-collapse: collapse;}" +
                "table, th, td {border: 1px solid black; padding: 10px; }" +
                ".bold { font-weight: bold; }" +
                ".data-record-table {border-collapse: collapse; border-spacing: 0; padding: 10px; width: 100%;" +
                "th {color: white; text-align: left; }" +
                "th, td { padding: 10px; } }" +
                ".custom-background{ background: #0e88b1; }" +
                ".blue-txt{color: #0e88b1; margin-left: 10px; }" +
                ".italic{ font-style: italic; }" +
                "</style>" +
                "</head>" +
                "<body>" +
                "<div>" +
                "<h3 style='text-align: center;'>" +
                dtr_title +
                "</h3>" +
                "<p style='color: grey; margin: 0px 0px 0px 10px !important;'>Version : " +
                this.__env.datarecordversion +
                " Date : " +
                str.substring(4, 10) +
                ", " +
                str.substring(11, 15) +
                "</p>" +
                "<table>" +
                "<tr>" +
                "<td>" +
                section_01.getElementsByTagName("div")[0].innerHTML +
                "</td>" +
                "<td>" +
                section_01.getElementsByTagName("div")[1].innerHTML +
                "</td>" +
                "</tr>" +
                "<tr>" +
                "<td colspan='2'>" +
                section_02 +
                "</td>" +
                "</tr>" +
                "<tr>" +
                "<td colspan='2'>" +
                section_03 +
                "</td>" +
                "</tr>" +
                "<tr>" +
                "<td colspan='2'>" +
                section_04 +
                "</td>" +
                "</tr>" +
                "<tr>" +
                "<td colspan='2'>" +
                section_05 +
                "</td>" +
                "</tr>" +
                "<tr>" +
                "<td colspan='2'>" +
                "<p class='bold'>" +
                section_06.getElementsByTagName("p")[0].innerHTML +
                "</p>" +
                "<p>" +
                section_06.getElementsByTagName("p")[1].innerHTML +
                "</p>" +
                "<p>" +
                section_06.getElementsByTagName("p")[2].innerHTML +
                "</p>" +
                "</td>" +
                "</tr>" +
                "<tr>" +
                "<td colspan='2'>" +
                "<p class='bold'>" +
                section_07.getElementsByTagName("p")[0].innerHTML +
                "</p>" +
                "<p>" +
                section_07.getElementsByTagName("p")[1].innerHTML +
                "</p>" +
                this.personalData() +
                "</td>" +
                "</tr>" +
                "<tr>" +
                "<td colspan='2'>" +
                section_08 +
                "</td>" +
                "</tr>" +
                "<tr>" +
                "<tr>" +
                "<td colspan='2'>" +
                section_09 +
                "</td>" +
                "</tr>" +
                "<tr>" +
                "<tr>" +
                "<td colspan='2'>" +
                section_10 +
                "</td>" +
                "</tr>" +
                "</table>" +
                "</div>" +
                "</body>" +
                "</html>";

            return html;
        }

        personalData() {
            let pElem = "";
            angular.forEach(this.datarecord, (value, key) => {
                if (this.options[key] && value == "1") {
                    pElem =
                        pElem +
                        "<p class='blue-txt'>" +
                        this.options[key] +
                        "</p>";
                }
            });

            if (pElem == "")
                return "<p>You have indicated that none of the personal data is defined as special category</p>";
            return pElem;
        }
    },
};

angular
    .module("dataRecord", [])
    .component(DataRecordDialogComponent.selector, DataRecordDialogComponent);
